import { useState, useEffect } from "react";
import { API_BASE } from "@config/env";
import axios from "axios";
import SectionCard from "./SectionCard";

const post = (ep, f) => {
  const fd = new FormData();
  Object.entries(f).forEach(([k,v]) => fd.append(k,v));
  return axios.post(`${API_BASE}${ep}`, fd).then(r=>r.data).catch(()=>null);
};

export default function RecruiterNotesTab({ resourceSlug, userSlug }) {
  const [notes,   setNotes]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [text,    setText]    = useState("");
  const [saving,  setSaving]  = useState(false);
  const [error,   setError]   = useState("");
  const [deletingSlug, setDeletingSlug] = useState(null);
  const [confirmSlug,  setConfirmSlug]  = useState(null);

  const load = () => {
    post("get-resource-details", { resource_slug: resourceSlug, user_slug: userSlug })
      .then(d => {
        const n = d?.resource_details?.recruiter_notes;
        setNotes(Array.isArray(n) ? n : []);
        setLoading(false);
      });
  };

  useEffect(() => { load(); }, [resourceSlug]);

  const addNote = async () => {
    if (!text.trim()) return;
    setSaving(true); setError("");
    const res = await post("create-note", { resource_slug: resourceSlug, r_slug: userSlug, note: text });
    setSaving(false);
    if (res?.status === 1) {
      setText("");
      load();
    } else {
      setError(res?.message || "Unable to save note. Please try again.");
    }
  };

  const deleteNote = async (noteSlug) => {
    setDeletingSlug(noteSlug); setConfirmSlug(null); setError("");
    const res = await post("remove-note", { r_slug: userSlug, note_slug: noteSlug });
    setDeletingSlug(null);
    if (res?.status === 1) {
      load();
    } else {
      setError(res?.message || "Unable to delete note. Please try again.");
    }
  };

  return (
    <SectionCard title="Recruiter Notes">
      <div style={{ marginBottom:14 }}>
        {error && <div style={{ padding:"9px 12px", background:"var(--fc-red-light)", border:"1px solid var(--fc-red-border)", borderRadius:9, marginBottom:10, fontSize:12.5, color:"var(--fc-red)" }}>{error}</div>}
        <textarea value={text} onChange={e=>setText(e.target.value)} rows={3}
          placeholder="Add a note about this candidate..."
          style={{ width:"100%", boxSizing:"border-box", padding:"9px 12px", border:"1.5px solid var(--fc-border)", borderRadius:9, fontSize:13, outline:"none", fontFamily:"inherit", resize:"vertical", background:"var(--fc-card-bg)", color:"var(--fc-text-primary)" }}
          onFocus={e=>e.target.style.borderColor="#2563EB"} onBlur={e=>e.target.style.borderColor="var(--fc-border)"} />
        <button onClick={addNote} disabled={saving||!text.trim()} className="fc-btn fc-btn-sm fc-btn-primary fc-btn-pill" style={{marginTop:8}}>
          {saving ? <><i className="fa-solid fa-spinner fa-spin me-1" style={{fontSize:10}}/>Saving...</> : "Add Note"}
        </button>
      </div>
      {loading
        ? <div style={{textAlign:"center",color:"var(--fc-text-subtle)",padding:"16px 0"}}><i className="fa-solid fa-spinner fa-spin"/></div>
        : notes.length === 0
          ? <div style={{color:"var(--fc-text-subtle)",fontSize:13,textAlign:"center",padding:"16px 0"}}>No notes yet. Add your first note above.</div>
          : notes.map((n,i) => {
              const isAuthor = n.r_slug && n.r_slug === userSlug;
              return (
              <div key={n.note_slug||i} style={{ padding:"12px 14px", background:"var(--fc-bg-light)", borderRadius:10, marginBottom:8, borderLeft:"3px solid #2563EB" }}>
                <p style={{ fontSize:13, color:"var(--fc-text-secondary)", lineHeight:1.6, margin:0 }}>{n.note}</p>
                <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginTop:6 }}>
                  <div style={{ fontSize:11, color:"var(--fc-text-subtle)" }}>
                    {n.r_name && <span style={{ fontWeight:600, color:"var(--fc-text-muted)" }}>{n.r_name}</span>}
                    {n.r_name && n.added_on && " · "}
                    {n.added_on}
                  </div>
                  {isAuthor && (
                    confirmSlug === n.note_slug ? (
                      <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                        <span style={{ fontSize:11, color:"var(--fc-text-subtle)" }}>Delete this note?</span>
                        <button onClick={()=>deleteNote(n.note_slug)} disabled={deletingSlug===n.note_slug}
                          style={{ background:"none", border:"none", cursor:"pointer", color:"var(--fc-red)", fontSize:11, fontWeight:700, padding:0 }}>
                          {deletingSlug===n.note_slug ? "..." : "Yes"}
                        </button>
                        <button onClick={()=>setConfirmSlug(null)}
                          style={{ background:"none", border:"none", cursor:"pointer", color:"var(--fc-text-subtle)", fontSize:11, padding:0 }}>
                          No
                        </button>
                      </div>
                    ) : (
                      <button onClick={()=>setConfirmSlug(n.note_slug)} title="Delete note"
                        style={{ background:"none", border:"none", cursor:"pointer", color:"var(--fc-text-hint)", fontSize:11, padding:2 }}
                        onMouseEnter={e=>e.currentTarget.style.color="var(--fc-red)"}
                        onMouseLeave={e=>e.currentTarget.style.color="var(--fc-text-hint)"}>
                        <i className="fa-solid fa-trash-can" />
                      </button>
                    )
                  )}
                </div>
              </div>
            );})
      }
    </SectionCard>
  );
}